/**
 * timePicker 목록 생성
 * @params type (H: 시간, M: 분)
 * @returns 시간/분 목록
 */
function getTimePickerList(type) {
  const maxVal = type === 'H' ? 23 : 59;
  let arr = [];
  for (var i = 0; i <= maxVal; i++) {
    arr.push(`${i < 10 ? '0' + i : i}`);
  }
  return arr;
}

export { getTimePickerList };
